import styled from 'styled-components'

import theme, { breakpoint } from 'style/theme'

export default styled.div`

.header {
    text-align: center;
    .title {
      color: ${theme.dark};
      font-size: 36px;
    }

    .sub-title {
      color: ${theme.darkGray};
      font-size: 22px;
    }
  }

  .service-content {
    margin-top: 24px;
    padding: ${props => (props.serviceItems < 5 ? '0 112px' : '')};
    display: grid;
    row-gap: 40px;
    column-gap: 30px;
    grid-template-columns: repeat(${props => props.serviceItems < 5 ? 4 : 5}, 1fr);
  }

  @media (max-width: ${breakpoint.lg}) {
    .service-content {
      display: grid;
      padding: 0;
      row-gap: 28px;
      column-gap: 18px;
      grid-template-columns: repeat(3, auto);
    }
  }

  @media (max-width: ${breakpoint.md}) {
    .service-content {
      display: grid;
      row-gap: 18px;
      column-gap: 16px;
      grid-template-columns: repeat(2, auto);
    }
  }
`
